import styled from '@emotion/styled';

interface ICtaButtonStyleProps {
  textColor: string;
  buttonBackground: string;
}

export const ButtonContainer = styled.button<ICtaButtonStyleProps>`
  font-family: Arial, Helvetica, sans-serif !important;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  white-space: nowrap;
  z-index: 100;
  cursor: pointer;
  bottom: 16px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 44px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 24px;
  padding-left: 16px;
  padding-right: 16px;
  -webkit-transition:
    padding 0.15s,
    background-color 0.05s;
  transition:
    padding 0.15s,
    background-color 0.05s;
  background-image: linear-gradient(to top, #1976d2, #1976d2);
  color: ${({ textColor }) => textColor || '#FFFFFF'};
  background: ${({ buttonBackground }) => buttonBackground || '#3c425c'};
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  overflow-x: hidden;
`;
